module.exports = __webpack_public_path__ + "hero-next-320-76891253ece8af8a16bf3e26b6e71b54.bundle.webp";